import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { GuidedTourButtonComponent } from './guided-tour-button.component';
import { GuidedTourService } from './guided-tour.service';

@NgModule({
  imports: [CommonModule, GuidedTourButtonComponent, TourMatMenuModule],
  providers: [GuidedTourService],
  exports: [TourMatMenuModule, GuidedTourButtonComponent],
})
export class GuidedTourModule {}
